import clone from 'lodash/cloneDeep';
import { updateSupportData, updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { viewIdSelector } from './AccountsManualStepSelector';
import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';

const RETIREMENT_ACCOUNTS = [5, 7, 25, 26, 17, 19, 27, 4, 22, 10, 23, 11];
const RETIREMENT_EARMARK = { Tooltip: 'Retirement', Type: 'Retirement' };
const RETIREMENT_TYPE = 'Retirement';

/**
 * Adds a default "retirement" earmark for retirement accounts
 *
 * @param {object} account - Account data
 * @returns {object} - New account data (with the retirement earmark added
 * for retirement accounts).
 */
const accountWithDefaultEarmark = account => {
  if (RETIREMENT_ACCOUNTS.includes(account.AccountType)) {
    return {
      ...account,
      AccountEarmark: [RETIREMENT_EARMARK],
      'AccountEarmark[Type]': [RETIREMENT_TYPE],
    };
  }
  return account;
};

export const setViewId = (viewId, workflowId) => (dispatch, getState) => {
  const previousViewId = viewIdSelector(getState(), { workflowId });
  dispatch(
    updateSupportData(
      {
        [BACKEND_KEY]: {
          accountViewId: viewId,
          previousViewId,
        },
      },
      workflowId,
    ),
  );
};

export const setDraftAccount = (draftAccount, workflowId) => dispatch => {
  // Make sure to clear the previous draft, otherwise it would get merged
  dispatch(
    updateSupportData(
      {
        [BACKEND_KEY]: {
          accountDraft: null,
        },
      },
      workflowId,
    ),
  );
  dispatch(
    updateSupportData(
      {
        [BACKEND_KEY]: {
          accountDraft: clone(draftAccount),
        },
      },
      workflowId,
    ),
  );
};

export const updateDraftAccount = (draftAccount, workflowId, clientId) => dispatch => {
  dispatch(
    updateSupportData(
      {
        [BACKEND_KEY]: {
          accountDraft: draftAccount,
        },
      },
      workflowId,
      clientId,
    ),
  );
};

export const addDraftAccount = (draft, graphAccounts, workflowId, clientId) => dispatch => {
  const newDraft = accountWithDefaultEarmark(draft);
  dispatch(
    updateData(
      {
        [BACKEND_KEY]: graphAccounts.concat(newDraft),
      },
      workflowId,
      clientId,
    ),
  );
};

export const saveDraftAccount = (draft, graphAccounts, workflowId, clientId) => dispatch => {
  const newDraft = accountWithDefaultEarmark(draft);
  dispatch(
    updateData(
      {
        [BACKEND_KEY]: graphAccounts.map(graphAccount => {
          if (
            (newDraft.AccountId !== null && graphAccount.AccountId === newDraft.AccountId) ||
            (newDraft.AccountId === null && graphAccount.frontEndId === newDraft.frontEndId)
          ) {
            return clone(newDraft);
          }
          return graphAccount;
        }),
      },
      workflowId,
      clientId,
    ),
  );
};
